import { PaymentSourceStatusEnum } from '@/types/generated/graphql';
import { CardStatusType } from '../payment-methods.types';
import { TFunction } from 'i18next';

export function getCardStatus(status?: PaymentSourceStatusEnum | null, t?: TFunction): CardStatusType {
  switch (status) {
    case PaymentSourceStatusEnum.expired:
      return {
        validityStatusMessage: t?.('card_is_expired'),
        iconType: 'error',
        tag: t?.('expired'),
        colorTag: 'var(--color-red-600)',
      };
    case PaymentSourceStatusEnum.expiring:
      return {
        validityStatusMessage: t?.('card_is_expiring_soon'),
        iconType: 'warning',
        tag: t?.('expiring_soon'),
        colorTag: 'var(--color-amber-700)',
      };
    case PaymentSourceStatusEnum.invalid:
      return {
        validityStatusMessage: t?.('card_is_invalid_and_cant_be_used_for_payments_right_now'),
        iconType: 'error',
        tag: t?.('invalid'),
        colorTag: 'var(--color-red-600)',
      };
    default:
      return {};
  }
}
